import { Particle, type ParticleOptions } from "../Particle";
import { MovesLiquid } from "../behaviors/MovesLiquid";
import { PhaseChange } from "../behaviors/PhaseChange";
import { TemperatureNormalization } from "../behaviors/TemperatureNormalization";
import { HeatTransfer } from "../behaviors/HeatTransfer";
import { Steam } from "./Steam";
import { Ice } from "./Ice";
import { adjustColor } from "../../utils/color";

export class Water extends Particle {
    static baseColor = 0x448AFF; // Vibrant Blue

    constructor(options: Partial<ParticleOptions> = {}) {
        super({
            name: "Water",
            color: adjustColor(Water.baseColor, 15),
            behaviors: [
                new MovesLiquid(),
                new HeatTransfer(0.1), // 水是良好的导热体
                new PhaseChange([
                    { temp: 100, type: 'above', factory: () => new Steam({ temperature: 100 }), probability: 0.2 },
                    { temp: 0, type: 'below', factory: () => new Ice({ temperature: -4 }), probability: 0.1 }
                ]),
                new TemperatureNormalization(20, 0.1) // 慢慢恢复到室温 (降低冷却速度配合加热)
            ],
            props: { isLiquid: true },
            temperature: 20,
            minTemp: -100,
            maxTemp: 200,
            ...options
        });
    }
}
